import { useState } from 'react';
import { Stack } from '@mui/material';
import GiftCardIcon from '@mui/icons-material/CardGiftcard';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import useGetGiftCardsOverview from '../../hooks/giftCards/useGetGiftCardsOverview';
import GiftCardsOverview from './GiftCardsOverview';
import GiftCardsTable from './GiftCardsTable';
import PageLoading from '../global/PageLoading';
import OutlinedPageBox from '../global/OutlinedPageBox';
import CenteredContentLayout from '../global/CenteredContentLayout';
import GiftCardSettingsModal from './GiftCardSettingsModal';
import { canManageGiftCards } from '../../helpers/gift-cards';
import useUser from '../../hooks/global/useUser';

function GiftCardsTab() {
  const { user } = useUser();
  const { data: overview, isLoading } = useGetGiftCardsOverview();

  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  const isEditingAllowed = canManageGiftCards(user);

  if (isLoading) {
    return <PageLoading />;
  }

  return (
    <>
      <Stack gap={2}>
        {overview?.hasGiftCards ? (
          <>
            <GiftCardsOverview overview={overview} />
            <GiftCardsTable setIsSettingsOpen={setIsSettingsOpen} />
          </>
        ) : (
          <OutlinedPageBox>
            <CenteredContentLayout
              image={GiftCardIcon}
              title="No gift cards found"
              description="Sell your first gift card to see your gift cards here!"
              imageMaxWidth="120px"
              secondaryButton={
                isEditingAllowed
                  ? {
                      text: 'Gift Card Settings',
                      icon: SettingsOutlinedIcon,
                      onClick: () => {
                        setIsSettingsOpen(true);
                      },
                    }
                  : undefined
              }
            />
          </OutlinedPageBox>
        )}
      </Stack>
      {isSettingsOpen && isEditingAllowed && (
        <GiftCardSettingsModal open onClose={() => setIsSettingsOpen(false)} />
      )}
    </>
  );
}

export default GiftCardsTab;
